import clsx from "clsx";
import {Box, Theme, Typography, useMediaQuery} from "@material-ui/core";
import {Energy5Link} from "../energy5/atoms";
import React from "react";
import {makeStyles} from "@material-ui/styles";
import useI18n from "evcharging/hooks/useI18n";

export const NewServiceCard = ({title, url, bgImage, onClick, subtitle, isFirst, bgImageMob}) => {
  const classes = useStyles({isFirst});
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const {t} = useI18n();

  return (
    <Box
      className={clsx(classes.serviceCard)}
      style={{backgroundImage: `url(${isSmall ? bgImageMob : bgImage})`}}
      onClick={onClick}
    >
      <Box width={`100%`} height={'auto'} overflow="hidden">
        <Typography variant="h1" className={classes.title}>
          {title.toUpperCase()}
          {isSmall
            ?
            !!subtitle && <>{' '}{subtitle.toUpperCase()} </>
            :
            !!subtitle && <><br/>{subtitle.toUpperCase()} </>
          }
        </Typography>

        <Box className={classes.linkContainer}>
          <Energy5Link text={t('action.explore')} href={url} className={classes.link}/>
        </Box>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles<Theme, { isFirst: boolean }>((theme: Theme) => {
  return {
    serviceCard: {
      willChange: 'width, opacity, min-height',
      transition: 'opacity .3s, width .3s, min-height .3s',
      backgroundPosition: 'top',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      padding: theme.spacing(3, 5, 6),
      color: 'black',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      minHeight: ({isFirst}) => (isFirst ? 376 : 188),
      maxHeight: ({isFirst}) => (isFirst ? 376 : 188),
      [theme.breakpoints.up('md')]: {
        transition: 'opacity .3s, width .3s',
        minHeight: ({isFirst}) => (isFirst ? 720 : 720),
        maxHeight: ({isFirst}) => (isFirst ? 720 : 720),
        justifyContent: 'flex-end',
        padding: theme.spacing(18, 5),
        '&:hover': {
          cursor: 'pointer',
        },
      },
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(18, 5, 21),
      },
    },
    title: {
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      fontSize: '32px',
      lineHeight: '32px',
      [theme.breakpoints.up('md')]: {
        whiteSpace: 'pre-line',
        fontSize: '38px',
        fontWeight: 800,
        lineHeight: '38px',
      },
      [theme.breakpoints.up('lg')]: {
        fontSize: '48px',
        lineHeight: '48px',
      },
    },
    text: {
      color: theme.palette.common.white,
      whiteSpace: 'pre-wrap',
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(8),
      },
    },
    linkContainer: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #F9C106',
      padding: theme.spacing(1.2, 6),
      borderRadius: 6,
      maxWidth: 120,
      minWidth: 120,
      backgroundColor: '#0B0B0BB2'
    },
    link: {
      fontSize: 16,
      color: '#F9C106',
      background: 'none',
      padding: 0,
      fontWeight: 600,
      '&:hover': {
        background: 'none',
      },
    },
    linkArrow: {
      transition: 'transform .2s'
    }
  };
});
